<template>
  <div
    id="login-method-form"
    class="form"
  >
    <div class="form-group">
      <tc-email class="tc-icon fs-unmask" />
      <label
        class="fs-unmask"
        for="login-email"
      >
        {{ $t('login.form.email') }}
      </label>
      <input
        id="login-email"
        v-model="loginMethodUserName"
        v-validate="'required|email'"
        name="email"
        type="text"
        class="form-control username playback-hide"
        placeholder="me@example.com"
        @keyup.enter="findLoginMethod"
      >
    </div>
    <div
      v-if="showWarning"
      id="pending-invite-login-failure-warning"
      class="warning-alert fs-unmask"
    >
      <p
        id="pending-invite-login-failure-warning-header"
        class="font-weight-bold"
      >
        {{ $t('login.pendingInvite.warning.header') }}
      </p>
      <p id="pending-invite-login-failure-warning-text">
        {{ $t('login.pendingInvite.warning.description') }}
      </p>
    </div>
    <tc-v-btn
      id="login-next-button"
      class="btn-primary"
      block
      :disabled="!findLoginMethodFormIsValid"
      @click="findLoginMethod"
    >
      {{ $t('login.loginMethodForm.button') }}
    </tc-v-btn>
  </div>
</template>

<script>
import TcEmail from '@/components/shared/icons/TcEmail'

export default {
  name: 'LoginMethod',
  components: {
    TcEmail
  },
  data () {
    return {
      loginMethodUserName: null,
      showWarning: false
    }
  },
  computed: {
    findLoginMethodFormIsValid () {
      return !this.errors.any() && this.loginMethodUserName !== null
    }
  },
  methods: {
    async findLoginMethod () {
      if (this.findLoginMethodFormIsValid) {
        this.$emit('update-login-method-user-name', this.loginMethodUserName)
        try {
          const response = await this.$http.post('api/users/identityProvider', {
            username: this.loginMethodUserName
          })
          if (response.data.userPending) {
            this.showWarning = true
          } else {
            this.$emit('update-login-method-type', response.data.identityProvider.name)
          }
        } catch (error) {
          console.error(error)
          const { response = {} } = error || {}
          if (response.status === 404) {
            this.$emit('show-all-login-methods')
          } else {
            this.$toast(this.$t('error.internalServerError'), 'danger')
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import 'Login';

  .warning-alert {
    padding: 5px;
    background: var(--t-color-surface);
    border: 1px solid var(--t-color-border);
    margin-bottom: 10px;
  }
</style>
